import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SocketIoModule } from 'ngx-socket-io';
import { ChatComponent } from './chat.component';
import { UserListDialogComponent } from './dialog/user-list-dialog/user-list-dialog.component';
import { YesNoDialogComponent } from './dialog/yes-no-dialog/yes-no-dialog.component';
import { ChatService } from './services/chat.service';
import { SharedModule } from './shared.module';
import { ActiveHoursDialogComponent } from './dialog/active-hours/active-hours-dialog.component';
import { GenericMessageDialogComponent } from './dialog/generic-message-dialog/generic-message-dialog.component';

@NgModule({
  declarations: [
    ChatComponent,
    YesNoDialogComponent,
    UserListDialogComponent,
    ActiveHoursDialogComponent,
    GenericMessageDialogComponent
  ],
  imports: [
    SharedModule,
    TranslateModule
  ],
  exports: [
    ChatComponent
  ],
  providers: [
    { provide: MatDialogRef, useValue: {} },

  ]
})

export class ChatModule {
  static forRoot(environment): ModuleWithProviders<ChatModule> {
    return {
      ngModule: ChatModule,
      providers: [
        ChatService, { provide: 'environment', useValue: environment },
      ]
    };
  }
}


